// tslint:disable-next-line: strict-type-predicates
export const noWindow = (): boolean => typeof window === 'undefined'
